/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import cn from 'clsx';
import { apiCreateDocumentType } from 'api/document-management';
import { AModal, AButton, ASelectCreate } from 'components/Antd';
import classes from './EditTypeModal.module.scss';

const EditTypeModal = ({
  open,
  onClose,
  typeOptions,
  onSubmit,
  defaultSelectedDocument,
  reloadData,
}) => {
  const [val, setVal] = useState(null);
  const [newOptions, setNewOptions] = useState([]);
  const options = (typeOptions || []).map((obj) => ({
    ...obj,
    value: obj.obj?.id,
  }));
  const handleCreateNewType = async (newOption) => {
    try {
      setVal(newOption.value);
      const res = await apiCreateDocumentType({
        name: newOption.value,
        type: 'documentType',
      });
      if (res?.data?.data?.id) {
        setVal(res?.data?.data?.id);
        setNewOptions([...newOptions, { value: res?.data?.data?.id, label: newOption.value }]);
        if (reloadData) reloadData();
      }
    } catch (error) {}
  };

  useEffect(() => {
    if (!!defaultSelectedDocument?.type?.id) {
      setVal(defaultSelectedDocument.type?.id);
    }
  }, []);

  return (
    <AModal
      title="Edit Type"
      open={open}
      onCancel={onClose}
      closable
      width={541}
      className={cn(classes.modalWrapper)}>
      <div className={classes.content}>
        <ASelectCreate
          placeholder="Fill or select"
          options={[...options, ...newOptions]}
          value={val}
          onChange={(tVal) => {
            setVal(tVal);
          }}
          showSearch
          size="large"
          radius="md"
          allowClear
          onCreate={handleCreateNewType}
        />
      </div>
      <div className={classes.footer}>
        <AButton
          onClick={() => {
            if (!!val && onSubmit) {
              onSubmit(val);
            }
          }}
          htmlType="button"
          type="primary"
          disabled={!val}
          size="large"
          className={classes.confirmBtn}>
          Confirm
        </AButton>
      </div>
    </AModal>
  );
};

export default EditTypeModal;
